import FooterButtons from 'components/inputs/Material/FooterButtons'
import Info from 'components/inputs/Material/Info'
import Sentences from 'components/inputs/Material/Sentences'
import { FormFieldsContainer } from '../Shared/styles'

export default function NLU() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
        <Sentences />
      </FormFieldsContainer>
      <FooterButtons />
    </>
  )
}
